/**
 * Mock data for agenda module
 *
 * Data persists in-memory during the session (NO localStorage)
 */

// ============================================================
// INITIAL MOCK DATA (read-only templates)
// ============================================================

const INITIAL_EVENTS = [
  // MEETING events
  {
    id: 1,
    title: "Consulenza fiscale Rossi",
    type: "meeting",
    start_date: "2026-01-03",
    start_time: "09:00",
    end_time: "10:00",
    location: "Studio - Sala 1",
    participants: "mario.rossi@example.com",
    description: "Consulenza fiscale trimestrale per il cliente Rossi",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-01T10:00:00Z",
    updated_at: "2026-01-01T10:00:00Z",
  },
  {
    id: 2,
    title: "Audit preliminare SRL",
    type: "meeting",
    start_date: "2026-01-10",
    start_time: "09:30",
    end_time: "11:00",
    location: "Sede cliente",
    participants: "laura.bianchi@techcorp.it, team@audit.com",
    description: "Revisione documenti contabili",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-05T14:20:00Z",
    updated_at: "2026-01-05T14:20:00Z",
  },
  {
    id: 3,
    title: "Incontro Agenzia Entrate",
    type: "meeting",
    start_date: "2026-01-14",
    start_time: "10:00",
    end_time: "11:30",
    location: "Ufficio territoriale AE",
    participants: "",
    description: "Presentazione documentazione fiscale cliente Beta SpA",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-08T09:15:00Z",
    updated_at: "2026-01-08T09:15:00Z",
  },
  {
    id: 4,
    title: "Budget previsionale CSI Group",
    type: "meeting",
    start_date: "2026-01-16",
    start_time: "09:00",
    end_time: "12:00",
    location: "Sede CSI Group",
    participants: "cfo@csigroup.com, admin@csigroup.com",
    description: "Presentazione budget 2026 e previsioni Q1",
    send_reminder: true,
    is_recurring: false,
    add_video_link: true,
    created_at: "2026-01-10T11:30:00Z",
    updated_at: "2026-01-10T11:30:00Z",
  },

  // EVENTO events
  {
    id: 5,
    title: "Revisione bilancio Alpha",
    type: "evento",
    start_date: "2026-01-03",
    start_time: "11:00",
    end_time: "13:00",
    location: "Videoconferenza",
    participants: "team@alpha.it",
    description: "Analisi bilancio 2025",
    send_reminder: false,
    is_recurring: false,
    add_video_link: true,
    created_at: "2025-12-28T16:45:00Z",
    updated_at: "2025-12-28T16:45:00Z",
  },
  {
    id: 6,
    title: "Videochiamata Partner",
    type: "evento",
    start_date: "2026-01-08",
    start_time: "15:00",
    end_time: "16:00",
    location: "Google Meet",
    participants: "partner1@firm.com, partner2@firm.com",
    description: "Allineamento progetti Q1 2026",
    send_reminder: true,
    is_recurring: false,
    add_video_link: true,
    created_at: "2026-01-04T10:20:00Z",
    updated_at: "2026-01-04T10:20:00Z",
  },
  {
    id: 7,
    title: "Costituzione nuova SRL",
    type: "evento",
    start_date: "2026-01-15",
    start_time: "11:00",
    end_time: "12:30",
    location: "Studio notarile",
    participants: "notaio@studio.it, cliente@newco.it",
    description: "Atto costitutivo nuova società",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-08T14:10:00Z",
    updated_at: "2026-01-08T14:10:00Z",
  },
  {
    id: 8,
    title: "Consulenza investimenti Leone",
    type: "evento",
    start_date: "2026-01-16",
    start_time: "15:00",
    end_time: "16:30",
    location: "Studio - Sala 1",
    participants: "g.leone@investments.it",
    description: "Pianificazione finanziaria 2026",
    send_reminder: false,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-12T09:30:00Z",
    updated_at: "2026-01-12T09:30:00Z",
  },

  // ATTIVITA events
  {
    id: 9,
    title: "Elaborazione buste paga",
    type: "attivita",
    start_date: "2026-01-07",
    start_time: "14:00",
    end_time: "17:00",
    location: "",
    participants: "",
    description: "Elaborazione buste paga mensili clienti",
    send_reminder: false,
    is_recurring: true,
    add_video_link: false,
    created_at: "2026-01-02T08:00:00Z",
    updated_at: "2026-01-02T08:00:00Z",
  },
  {
    id: 10,
    title: "Controllo scadenze fiscali",
    type: "attivita",
    start_date: "2026-01-15",
    start_time: "14:00",
    end_time: "16:00",
    location: "",
    participants: "",
    description: "Verifica scadenze fiscali clienti per gennaio",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-10T15:20:00Z",
    updated_at: "2026-01-10T15:20:00Z",
  },
  {
    id: 11,
    title: "Controllo scadenze",
    type: "attivita",
    start_date: "2026-01-28",
    start_time: "09:00",
    end_time: "11:00",
    location: "",
    participants: "",
    description: "Revisione scadenze mensili",
    send_reminder: false,
    is_recurring: true,
    add_video_link: false,
    created_at: "2026-01-20T11:00:00Z",
    updated_at: "2026-01-20T11:00:00Z",
  },
  {
    id: 12,
    title: "Certificazione Unica 2024",
    type: "attivita",
    start_date: "2026-01-17",
    start_time: "09:00",
    end_time: "17:00",
    location: "",
    participants: "",
    description: "Preparazione CU per tutti i dipendenti clienti",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-12T16:00:00Z",
    updated_at: "2026-01-12T16:00:00Z",
  },

  // TASK events
  {
    id: 13,
    title: "Scadenza F24",
    type: "task",
    start_date: "2026-01-16",
    start_time: "16:00",
    end_time: "17:00",
    location: "",
    participants: "",
    description: "Invio F24 mensili clienti",
    send_reminder: true,
    is_recurring: true,
    add_video_link: false,
    created_at: "2026-01-10T08:30:00Z",
    updated_at: "2026-01-10T08:30:00Z",
  },
  {
    id: 14,
    title: "Scadenza versamenti",
    type: "task",
    start_date: "2026-01-13",
    start_time: "16:00",
    end_time: "17:00",
    location: "",
    participants: "",
    description: "Versamenti IVA e ritenute",
    send_reminder: true,
    is_recurring: true,
    add_video_link: false,
    created_at: "2026-01-05T13:15:00Z",
    updated_at: "2026-01-05T13:15:00Z",
  },
  {
    id: 15,
    title: "Scadenza liquidazione IVA",
    type: "task",
    start_date: "2026-01-16",
    start_time: "16:00",
    end_time: "17:00",
    location: "",
    participants: "",
    description: "Liquidazione IVA trimestrale",
    send_reminder: true,
    is_recurring: false,
    add_video_link: false,
    created_at: "2026-01-12T10:45:00Z",
    updated_at: "2026-01-12T10:45:00Z",
  },

  // Additional events for February 2026
  {
    id: 16,
    title: "Team Meeting Mensile",
    type: "meeting",
    start_date: "2026-02-03",
    start_time: "10:00",
    end_time: "11:30",
    location: "Studio - Sala Riunioni",
    participants: "team@studio.com",
    description: "Riunione mensile del team",
    send_reminder: true,
    is_recurring: true,
    add_video_link: false,
    created_at: "2026-01-28T09:00:00Z",
    updated_at: "2026-01-28T09:00:00Z",
  },
  {
    id: 17,
    title: "Formazione fiscale 2026",
    type: "evento",
    start_date: "2026-02-10",
    start_time: "09:00",
    end_time: "13:00",
    location: "Webinar",
    participants: "",
    description: "Aggiornamento normative fiscali 2026",
    send_reminder: true,
    is_recurring: false,
    add_video_link: true,
    created_at: "2026-01-25T14:30:00Z",
    updated_at: "2026-01-25T14:30:00Z",
  },
];

// ============================================================
// IN-MEMORY STATE (mutable during session)
// ============================================================

let eventsState = JSON.parse(JSON.stringify(INITIAL_EVENTS)); // Deep clone

// Track next ID for creating new entities
let nextEventId = Math.max(...INITIAL_EVENTS.map(e => e.id), 0) + 1;

// ============================================================
// STATE ACCESSORS & MUTATORS
// ============================================================

/**
 * Get current events state
 * @returns {Array}
 */
export const getEventsState = () => eventsState;

/**
 * Set events state
 * @param {Array} newEvents
 */
export const setEventsState = (newEvents) => {
  eventsState = newEvents;
};

/**
 * Get and increment next event ID
 * @returns {number}
 */
export const getNextEventId = () => {
  return nextEventId++;
};

/**
 * Reset all state to initial values (useful for testing)
 */
export const resetMockData = () => {
  eventsState = JSON.parse(JSON.stringify(INITIAL_EVENTS));
  nextEventId = Math.max(...INITIAL_EVENTS.map(e => e.id), 0) + 1;
};
